import { FALLBACK_HOME, useHomeContent } from '../lib/content';
import { Hero } from '../components/home/Hero';
import { ReturningBanner } from '../components/home/ReturningBanner';
import { AudienceSection } from '../components/home/AudienceSection';
import { BenefitsSection } from '../components/home/BenefitsSection';
import { LawyersSection } from '../components/home/LawyersSection';
import { StepsSection } from '../components/home/StepsSection';
import { ExpertiseSection } from '../components/home/ExpertiseSection';
import { TariffsSection } from '../components/home/TariffsSection';
import { FaqSection } from '../components/home/FaqSection';
import { CtaSection } from '../components/home/CtaSection';

export function HomePage() {
  const { data } = useHomeContent();
  const content = data ?? FALLBACK_HOME;

  return (
    <>
      <ReturningBanner />
      <Hero />
      <AudienceSection />
      <BenefitsSection />
      <LawyersSection lawyers={content.lawyers} />
      <StepsSection steps={content.steps} />
      <ExpertiseSection />
      <TariffsSection tariffs={content.tariffs} />
      <FaqSection faq={content.faq} />
      <CtaSection />
    </>
  );
}
